import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=4a630674&"
import script from "./pending.vue?vue&type=script&lang=ts&"
export * from "./pending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports